<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <b-row>
      <b-col :md="columnWith" v-for="(input, key) in fields" :key="key">
        <label :for="input.name">{{input.label}}
          <span v-if="input.required" class="text-danger">{{$t('form.required_star')}}</span>
        </label>
        <div class="mb-4">
          <b-form-input
            v-model="params[input.name]"
            :type="input.type"
            :required="input.required"
            :placeholder="input.placeholder"
            :name="input.name"
            :id="input.name"
            :min="input.min"
          />

          <div class="invalid-feedback position-absolute mt-0 text-left">
            {{$t('errors.error_validation')}}
          </div>

        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>

  export default {
    name: 'InviteView',
    middleware: 'auth',
    props: {
      fields: {
        type: Array,
        require: true
      },
      partner_id: {
        type: Number
      },
      columnWith: {
        type: Number,
        default: 4
      },
    },
    data() {
      return {
        params: {
          company: "",
          first_name: "",
          job: "",
          last_name: ""
        },
        debounceSubmit: () => {
        }
      }
    },
    mounted() {
    },
    watch: {
      partner_id(val) {
        if (val) {
          this.postData(`partners/${val}/invite`, this.params, '/partners')
        }
      }
    }
  }
</script>